export default __webpack_public_path__ + "static/appoverviewandtracking-f65839542bddada70e93cfa6535cc7be.svg";